import { VideoConsultCreateRoomResponse } from '@quromedical/models';
import React from 'react';

interface CreateMeetingCardProps {
  patientId: string;
  /**
   * Can be undefined to handle loading state
   */
  room?: VideoConsultCreateRoomResponse;

  handleJoinWaitingRoom: () => void;
}

export type CreateMeetingCardComponent = React.FC<CreateMeetingCardProps>;
